import { Button, type ButtonProps } from "@mui/material";
import { RGB_Log_Shade } from "~/app/utils/colors";

const CTA_THEMES = {
  primary: {
    borderColor: "rgb(172, 255, 206)",
    backgroundColor: "rgb(78, 202, 37)",
  },
} as const;

type TCTATheme = keyof typeof CTA_THEMES;

type TCTAButtonProps = ButtonProps & {
  theme?: TCTATheme;
};

export const CTAButton = ({ theme = "primary", sx, children, ...props }: TCTAButtonProps) => {
  return (
    <Button
      {...props}
      sx={{
        ...CTA_THEMES[theme],
        border: "1px solid",
        backgroundImage:
          "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.20) 100%)",
        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
        position: "relative",
        zIndex: 0,
        backgroundColor: CTA_THEMES[theme].backgroundColor,
        '&.Mui-disabled': {
          backgroundColor: 'rgba(78, 202, 37)',
          cursor: 'not-allowed',
          opacity:.7,
        },
        "&::after": {
          content: `''`,
          position: "absolute",
          zIndex: "-1",
          inset: 0,
          boxShadow: `inset 0px 0px 10px 5px ${RGB_Log_Shade(-0.5, CTA_THEMES[theme].backgroundColor)}`,
          borderRadius: "inherit",
        },
        ...sx,
      }}
    >
      {children}
    </Button>
  );
};
